<template>
  <div>
    <GlobalHead />
    <div style="width: 100%;">
      <div class="marginAuto">
        <div class="allWrapper">
          <div class="title">
            <span>当前位置：首页></span>
            <span>办件进度查询</span>
          </div>
          <div class="title1">
            <span>办件进度查询</span>
          </div>
          <div class="title2">
            <span>
              您可在此凭借办件编号查询办件进度，也可以
              <span class="blue">登录</span>
              后进入个人中心页找到办事记录，查看进度更方便。
            </span>
          </div>

          <div class="item1">
            <a-form :form="form" :layout="formLayout">
              <a-form-item
                :label-col="formItemLayout.labelCol"
                :wrapper-col="formItemLayout.wrapperCol"
                :layout="formLayout"
                label="办件编号"
              >
                <a-input
                  placeholder="请输入办件编号"
                  v-decorator="[
                    'handlingID',
                    { rules: [{ required: true, message: '办件编号不存在请重新输入' }] }
                  ]"
                />
              </a-form-item>
              <a-form-item
                :label-col="formItemLayout.labelColy"
                :wrapper-col="formItemLayout.wrapperColy"
                label="手机号码"
              >
                <a-input-search
                  :class="bianliang ? 'huise' : ''"
                  v-decorator="['mobile', { rules: [{ required: true, message: '手机号码不能未空' }] }]"
                  placeholder="请输入申请人手机号码"
                  @search="onSearch"
                >
                  <a-button slot="enterButton" class="yz" id="new_yan" :disabled="disabled">
                    <span v-show="show">获取验证码</span>
                    <span v-show="!show">{{ count }}秒后获取</span>
                  </a-button>
                </a-input-search>
                <span class="sendSuccess" v-show="sendSuccess">验证码短信已发送</span>
              </a-form-item>

              <a-form-item
                :label-col="formItemLayout.labelCol"
                :wrapper-col="formItemLayout.wrapperCol"
                label="验证码"
              >
                <a-input
                  placeholder="请输入验证码"
                  v-decorator="[
                    'yz',
                    { rules: [{ required: true, message: '验证码不能未空' }] }
                  ]"
                />
              </a-form-item>
            </a-form>
          </div>
          <div>
            <a-button class="btnStyle1" type="primary" @click="submit">
              <a-icon type="search"></a-icon>
              查询
            </a-button>
          </div>
        </div>
        <div class="message">
          <span>若查询无果,您可以:</span>
          <br />
          <span>1.拨打96359政务热线电话,寻求在线客服的帮助;</span>
          <br />
          <span>2.前往政务服务大厅。使用您的身份证在大厅服务及上进行查询;</span>
          <br />
          <span>3.登录政府服务网账号,进入个人中心进行查询;</span>
        </div>
      </div>
    </div>

    <!-- <GlobalFood /> -->
  </div>
</template>

<script>
import GlobalHead from '@/views/layout/globalHead'
// import GlobalFood from '@/views/layout/globalFood'
const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8 },
  labelColy: { span: 4 },
  wrapperColy: { span: 7 }
}
export default {
  name: 'QueryHandling',
  components: {
    GlobalHead
    // GlobalFood
  },
  data () {
    return {
      show: true,
      formItemLayout,
      formLayout: 'horizontal',
      form: this.$form.createForm(this),
      fhyzm: 1,
      bianliang: 0,
      count: 60,
      disabled: false,
      timer: null,
      sendSuccess: false
    }
  },
  methods: {
    onSearch () {
      this.form.validateFields(['mobile', 'handlingID'], err => {
        if (!err) {
          this.yz = 1
          alert('成功')
          this.count = 60
          this.show = false
          this.disabled = true
          this.bianliang = 1
          this.sendSuccess = true
          // 将鼠标设置为不可点击状态
          // document.getElementById('new_yan').style.cursor = 'not-allowed'
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= 60) {
              this.count--
              if (this.count === 57) {
                this.sendSuccess = false
              }
            } else {
              this.show = true
              clearInterval(this.timer)
              this.timer = null
              this.disabled = false
            }
          }, 1000)
        } else {
        }
      })
    },
    submit () {
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.yz === this.fhyzm) {
            alert('成功')
          }
        } else {
        }
      })
    },
    watch () {
      this.timer(val => {
        if (val == null) {
          //  监听timer变化，移除不可点击样式
          this.yz.removeClass('huise')
          this.disabled = false
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.marginAuto {
  width: 1200px;
  margin: auto;
}
.allWrapper {
  display: inline;
  background: #fff;
  width: 700px;
  float: left;
}
.title {
  margin-top: 20px;
}
.title1 {
  display: block;
  font-size: 22px;
  line-height: 40px;
  color: #000000;
  font-weight: normal;
  margin-top: 30px;
}
.title2 {
  font-size: 14px;
  color: #999999;
  margin-top: 10px;
}
.blue {
  font-size: 14px;
  font-weight: 550;
  color: #108ee9;
}
.item1 {
  margin-top: 30px;
}
.btnStyle1 {
  height: 40px;
  display: inline-block;
  width: 110px;
  color: #fff;
  background: #1777ff;
  line-height: 40px;
  text-align: center;
  border: 1px solid #fff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.yz {
  font-size: 17px;
  font-weight: 550;
  color: #108ee9;
}
.huise {
  background-color: #dcdcdc;
  color: black;
}
.sendSuccess {
  font-size: 19px;
  font-weight: 550;
  color: #108ee9;
}
.message {
  margin-top: 209px;
  width: 400px;
  height: 342px;
  border: 1px dashed #dddddd;
  float: left;
}
/deep/ .ant-form-item-label {
  text-align: left;
}
</style>
